import { useEffect, useState } from 'react';
import { promotionInfoStore } from '@/website/store/promotion/promotionInfoStore';

export default function PromotionTopBanner({ endDate, text }: { endDate?: string; text: string }) {
  const [seconds, setSeconds] = useState<number>(0);
  const [minutes, setMinutes] = useState<number>(0);
  const [hours, setHours] = useState<number>(0);
  const [days, setDays] = useState<number>(0);
  const {
    state: { promotionInfo },
  } = promotionInfoStore();
  const [customStylesInfo, setCustomStylesInfo] = useState({
    backgroundColor: '#0E35D1',
    color: '#fff',
    fontSize: '16px',
  });
  const [customText, setCustomText] = useState('');

  const timer = setInterval(() => {
    const date = new Date(endDate);
    const now = new Date();
    const diffTime = Math.abs(date.getTime() - now.getTime());
    const remainingDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const remainingHours = Math.floor((diffTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const remainingMinutes = Math.floor((diffTime % (1000 * 60 * 60)) / (1000 * 60));
    const remainingSeconds = Math.floor((diffTime % (1000 * 60)) / 1000);

    setDays(remainingDays);
    setHours(remainingHours);
    setMinutes(remainingMinutes);
    setSeconds(remainingSeconds);
  }, 1000);

  useEffect(() => {
    if (endDate) {
      timer;
    }

    return () => {
      clearInterval(timer);
    };
  }, [endDate]);

  useEffect(() => {
    const { top_banner_bg_color, top_banner_font_size, top_banner_text, primary_color } = promotionInfo?.banner_settings || {};
    setCustomStylesInfo({
      backgroundColor: top_banner_bg_color || '#0E35D1',
      color: primary_color || '#fff',
      fontSize: top_banner_font_size || '16px',
    });
    setCustomText(top_banner_text);
  }, [promotionInfo]);

  return !!promotionInfo?.end_date || !!promotionInfo?.banner_settings?.top_banner_text ? (
    <div className="z-50 flex w-full items-center justify-center py-2" style={customStylesInfo}>
      <p className="px-4 text-center font-bold">
        {customText}
        {endDate && <span> - Ends in {`${days}d ${hours}h ${minutes}m ${seconds}s`}</span>}
      </p>
    </div>
  ) : null;
}
